import React , { useState, useRef, useEffect, useCallback } from 'react';
import Slider from '@material-ui/core/Slider';
import { withStyles, makeStyles } from '@material-ui/core/styles';


const iOSBoxShadow = '0 3px 1px rgba(0,0,0,0.1), 0 4px 8px rgba(0,0,0,0.13), 0 0 0 1px rgba(0,0,0,0.02), inset -3px -3px 4px 1px rgba(0, 0, 0, 0.23)';



const IOSSlider = withStyles({
  root: {
    color:'rgba(255, 255, 255, 0.8)',
    height: 2,
    padding: '15px 0',
  },
  thumb: {
    height: '100%',
    margin: 0,
    marginLeft: -1,
    borderRadius: 0,
    width: 2,
    backgroundColor: 'yellow',
  },
  active: {},
  valueLabel: {
    display:'none',
  },
  track: {
    height: 1,
  },
  rail: {
    height: 1,
    opacity: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.8) !important',
  },
  mark: {
    backgroundColor: 'rgba(255, 255, 255, 0.8) !important',
    height: 12,
    width: 1,
    marginTop: 0,
    marginLeft: -1,
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.8) !important',
  },
})(Slider);

export default IOSSlider
